import moment from 'moment';
import i18next from 'i18next';

const asHours = (ms: number): number => {
  const duration = moment.duration(ms);

  return Math.trunc(duration.asHours());
};

const stringify = (
  ms: number,
  modifierPrefix: string,
  separator: string = ''
) => {
  if (typeof ms !== 'number') {
    throw new TypeError('Input must be a duration in ms');
  }

  const duration = moment.duration(ms);

  const hours = Math.trunc(duration.asHours());
  const minutes = duration.minutes();

  const parts = [];

  if (hours !== 0) {
    parts.push(
      `${i18next.t(`util-duration.${modifierPrefix}-hours`, { count: hours })}`
    );
  }
  if (minutes !== 0) {
    parts.push(
      `${i18next.t(`util-duration.${modifierPrefix}-minutes`, {
        count: minutes,
      })}`
    );
  }

  if (parts.length > 0) {
    return parts.join(separator);
  }

  return '';
};

export const stringifyShort = (ms: number) => {
  return stringify(ms, 'short', ' ');
};

export const stringifyLong = (ms: number) => {
  return stringify(ms, 'long', ' ');
};

export default {
  stringifyShort,
  stringifyLong,
  asHours,
};
